// Scripts librairies
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks'
import { docReady } from './js/libs/utils'

// Charge la base commune
require('./common.js')

// étend lazysize pour charger des scripts à la volée
window.lazySizesConfig = window.lazySizesConfig || {}
window.lazySizesConfig.requireJs = function (modules, cb) {
  window.require(modules, cb)
}

docReady(function () {
  // auto-anchor
  // let target = document.querySelector('#article-detail')
  // if (target) {
  //   setTimeout(() => {
  //     target.scrollIntoView({ behavior: 'smooth' })
  //   }, 800)
  // } else {
  let target = document.querySelector('[data-anchor="auto"]')
  if (target) {
    setTimeout(() => {
      target.scrollIntoView({ behavior: 'smooth' })
    }, 800)
  } else {
    target = document.querySelector('#articles')
    if (target) {
      setTimeout(() => {
        target.scrollIntoView({ behavior: 'smooth' })
      }, 800)
    }
  }
  // }
})
